<template>
  <examples-block
    gitUrl="src/components/examples/Modal/modalView/FirstModal.vue"
    title="Несколько модальных окон из под RPopover в первом модальном окне">
    <r-button
      title="Отрыть модальное окно"
      @click="openModal"
    />
  </examples-block>
</template>

<script>
import ExamplesBlock from '@/layouts/ExamplesBlock.vue';
import FirstModal from './modalView/FirstModal.vue';

export default {
  name: 'SecondModalOpenInPopover',
  components: { ExamplesBlock },
  methods: {
    openModal() {
      this.$rir.modal.open(FirstModal, {});
    },
  },
};
</script>
